<ng-container *ngIf="dropdownSelector">
  <div
    hidden
    infiniteScroll
    [infiniteScrollDisabled]="preventedScroll"
    [infiniteScrollContainer]="dropdownSelector"
    [infiniteScrollThrottle]="250"
    [fromRoot]="true"
    [scrollWindow]="true"
    (scrolled)="onScrollBottom()"
  ></div>
</ng-container>
